import { createContext } from 'react';

import type { ProductWithSharing } from '@/types/collaboration';
import type { PageContext } from '@/types/pageContext';

export type ChatSidebarMode = 'floating' | 'sidebar';

export type SelectedProductInfo = Pick<ProductWithSharing, 'id' | 'name'>;

export interface ConversationContext {
  toolId?: string;
  toolVersionId?: string;
  moduleId?: string;
}

export interface ChatSidebarContext {
  isOpen: boolean;
  mode: ChatSidebarMode;
  sidebarWidth: number;
  setSidebarWidth: (width: number) => void;
  openChat: (options?: {
    mode?: ChatSidebarMode;
    message?: string;
    newConversation?: boolean;
    selectedProducts?: Record<string, SelectedProductInfo>;
    conversationId?: string;
    conversationContext?: ConversationContext;
    focusInput?: boolean;
    conversationTitle?: string;
  }) => void;
  closeChat: () => void;
  toggleChat: () => void;
  switchMode: (newMode: ChatSidebarMode) => void;
  currentConversationId: string | null;
  setCurrentConversationId: (id: string | null) => void;
  draftMessage: string;
  setDraftMessage: (message: string) => void;
  pendingNewConversation: boolean;
  pendingMessage: string | null;
  pendingSelectedProducts: Record<string, SelectedProductInfo>;
  pendingConversationContext: ConversationContext;
  pendingConversationTitle: string | undefined;
  clearPendingNewConversation: () => void;
  pendingFocusInput: boolean;
  setPendingFocusInput: (focus: boolean) => void;
  pageContext: PageContext | null;
  setPageContext: (context: PageContext | null) => void;
}

export const ChatSidebarContext = createContext<ChatSidebarContext | null>(
  null
);
